import { all, fork } from 'redux-saga/effects';

import listenLoadOccupiedDates from './listenLoadOccupiedDates';

export default function* bookingSaga() {
  yield all([fork(listenLoadOccupiedDates)]);
}
